document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper === 'undefined') return;

  const mainEl = document.querySelector('.product-offer__main-slider');
  const navEl = document.querySelector('.product-offer__nav-slider');

  if (!mainEl) return;

  const oneTimeGallery = mainEl.closest('.is-one-time-gallery');

  if (oneTimeGallery) {
    const mainSlider = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      watchOverflow: true,
      navigation: {
        nextEl: oneTimeGallery.querySelector('.swiper-button-next-button'),
        prevEl: oneTimeGallery.querySelector('.swiper-button-prev-button'),
      }
    });

    const thumbEl = oneTimeGallery.querySelector('.product-offer__thumb-slider');
    const thumbs = oneTimeGallery.querySelectorAll('.product-offer__thumb');
    const thumbSlider = thumbEl ? new Swiper(thumbEl, {
      slidesPerView: 4,
      spaceBetween: 10,
      watchOverflow: true,
    }) : null;

    const revealThumb = (index) => {
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === index);
      });
      if (!thumbSlider) return;
      const visible = 4;
      const start = thumbSlider.activeIndex;
      if (index < start) thumbSlider.slideTo(index);
      else if (index > start + visible - 1) thumbSlider.slideTo(index - visible + 1);
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.getAttribute('data-thumb-index'));
        if (Number.isNaN(index)) return;
        mainSlider.slideTo(index);
        revealThumb(index);
      });
    });

    mainSlider.on('slideChange', () => {
      revealThumb(mainSlider.activeIndex);
    });
  } else {
  let sliderThumbnail = null;

  if (navEl) {
    const thumbsBelow = Boolean(navEl.closest('.is-thumbs-below'));

    if (!thumbsBelow) {
      function syncNavHeight() {
        navEl.style.height = mainEl.offsetHeight + 'px';
      }

      syncNavHeight();
      window.addEventListener('resize', syncNavHeight);
    }

    sliderThumbnail = new Swiper(navEl, {
      slidesPerView: thumbsBelow ? 'auto' : 5,
      spaceBetween: thumbsBelow ? 10 : 12,
      direction: thumbsBelow ? 'horizontal' : 'vertical',
      watchSlidesProgress: true,
    });
  }

  new Swiper(mainEl, {
    spaceBetween: 8,
    slidesPerView: 1.16,
    loop: mainEl.querySelectorAll('.swiper-slide').length > 1,
    thumbs: sliderThumbnail ? { swiper: sliderThumbnail } : undefined,
    navigation: {
      nextEl: '.swiper-button-next-button',
      prevEl: '.swiper-button-prev-button',
    },
    breakpoints: {
      581: {
        slidesPerView: 1,
        loop: false,
      }
    }
  });
  }

  const testimonialSliderEl = document.querySelector('.product-offer__testimonial-slider');
  if (testimonialSliderEl) {
    const testimonialSlides = testimonialSliderEl.querySelectorAll('.swiper-slide');

    new Swiper(testimonialSliderEl, {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: testimonialSlides.length > 1,
      autoplay: testimonialSlides.length > 1 ? {
        delay: 5000,
        disableOnInteraction: false
      } : false
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const buyNowBtn = document.getElementById('buy-now');
  const variantInput = document.getElementById('selected-variant-id');
  const subscriptionCheckbox = document.getElementById('offer-subscription');
  const variantItems = document.querySelectorAll('.product-offer__variant-item');

  if (!buyNowBtn || !variantInput) return;

  const form = buyNowBtn.closest('form');
  if (!form) return;

  const stickyPrice = document.querySelector('.product-offer__sticky .btn-price');
  const stickyCompare = document.querySelector('.product-offer__sticky .btn-compare');
  const btnPrice = buyNowBtn.querySelector('.btn-price');
  const btnCompare = buyNowBtn.querySelector('.btn-compare');

  form.addEventListener('submit', e => e.preventDefault());

  function getSelectedVariant() {
    return document.querySelector('.product-offer__variant-item.selected') || variantItems[0] || null;
  }

  function getVariantId() {
    const selected = getSelectedVariant();
    if (selected && selected.dataset.id) return selected.dataset.id;
    return variantInput.value;
  }

  const giftsUnlocked = form.querySelector('[data-gifts-unlocked]');

  function classifyGiftImage(img) {
    if (!img || !img.closest) return;

    const media = img.closest('.product-offer__gifts-unlocked-media');
    if (!media) return;

    const applyAspect = () => {
      const w = img.naturalWidth || 0;
      const h = img.naturalHeight || 0;
      if (!w || !h) return;

      const ratio = w / h;
      media.classList.toggle('is-landscape', ratio >= 1.35);
      media.classList.toggle('is-portrait', ratio < 1.35);
    };

    if (img.complete && img.naturalWidth) {
      applyAspect();
    } else {
      img.addEventListener('load', applyAspect, { once: true });
    }
  }

  function classifyAllGiftImages() {
    if (!giftsUnlocked) return;
    giftsUnlocked.querySelectorAll('.product-offer__gifts-unlocked-img').forEach(classifyGiftImage);
  }

  function updateGiftsUnlocked() {
    if (!giftsUnlocked) return;

    const selected = getSelectedVariant();

    giftsUnlocked.querySelectorAll('[data-gift-index]').forEach((giftEl) => {
      const giftIndex = Number(giftEl.getAttribute('data-gift-index') || 0);
      const imgUrl = selected
        ? (selected.getAttribute(`data-gift-img-${giftIndex}`) || '').trim()
        : '';
      const title = selected
        ? (selected.getAttribute(`data-gift-title-${giftIndex}`) || '').trim()
        : '';
      const price = selected
        ? (selected.getAttribute(`data-gift-price-${giftIndex}`) || '').trim()
        : '';

      const unlocked = Boolean(imgUrl);
      giftEl.classList.toggle('is-unlocked', unlocked);
      giftEl.classList.toggle('is-locked', !unlocked);

      const slotImg = giftEl.querySelector('[data-gift-slot-img]');
      const placeholder = giftEl.querySelector('[data-gift-slot-placeholder]');
      const priceEl = giftEl.querySelector('[data-gift-slot-price]');
      const titleEl = giftEl.querySelector('[data-gift-slot-title]');
      const lockedEl = giftEl.querySelector('.product-offer__gifts-unlocked-status.is-locked-label');

      if (slotImg) {
        if (imgUrl) {
          if (slotImg.getAttribute('src') !== imgUrl) {
            slotImg.setAttribute('src', imgUrl);
          }
          slotImg.alt = title;
          slotImg.hidden = false;
          if (placeholder) placeholder.hidden = true;
          classifyGiftImage(slotImg);
        } else {
          slotImg.removeAttribute('src');
          slotImg.hidden = true;
          if (placeholder) placeholder.hidden = false;
        }
      }

      if (priceEl) {
        priceEl.textContent = price;
        priceEl.hidden = !(unlocked && price);
      }

      if (titleEl) {
        titleEl.textContent = title;
        titleEl.hidden = !(unlocked && title);
      }

      if (lockedEl) {
        lockedEl.hidden = unlocked;
      }
    });

    classifyAllGiftImages();
  }

  function updatePrices() {
    const isSub = subscriptionCheckbox && subscriptionCheckbox.checked;

    variantItems.forEach(item => {
      const priceEl = item.querySelector('.el-price');
      const compareEl = item.querySelector('.el-compare-price');
      const saveEl = item.querySelector('.product-offer__variant-save');

      let price = item.dataset.price;

      if (isSub && item.dataset.subscriptionPrice) {
        price = item.dataset.subscriptionPrice;
      }

      if (priceEl) priceEl.textContent = price;

      if (compareEl) compareEl.textContent = item.dataset.comparePrice;

      if (saveEl) {
        const savePercent = isSub
          ? Number(item.dataset.savePercentSub || 0)
          : Number(item.dataset.savePercent || 0);

        if (savePercent > 0) {
          saveEl.textContent = `SAVE ${savePercent}%`;
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
    });

    const selected = getSelectedVariant();
    updateGiftsUnlocked();
    if (!selected || !btnPrice) return;

    let activePrice = selected.dataset.price;

    if (isSub && selected.dataset.subscriptionPrice) {
      activePrice = selected.dataset.subscriptionPrice;
    }

    btnPrice.textContent = activePrice;

    const comparePrice = selected.dataset.comparePrice || '';
    const showCompare = Boolean(comparePrice) && comparePrice !== activePrice;

    if (btnCompare) {
      btnCompare.textContent = comparePrice;
      btnCompare.hidden = !showCompare;
    }

    if (stickyPrice) {
      stickyPrice.textContent = activePrice;
    }

    if (stickyCompare) {
      stickyCompare.textContent = comparePrice;
      stickyCompare.hidden = !showCompare;
    }
  }

  variantItems.forEach(item => {
    item.addEventListener('click', () => {
      variantItems.forEach(v => v.classList.remove('selected'));
      item.classList.add('selected');
      variantInput.value = item.dataset.id;
      updatePrices();
    });
  });

  if (subscriptionCheckbox) {
    subscriptionCheckbox.addEventListener('change', updatePrices);
  }

  function openThemeCartDrawer() {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    if (window.elThemeCartDrawer && typeof window.elThemeCartDrawer.open === 'function') {
      window.elThemeCartDrawer.open();
      return;
    }
    if (window.elCartDrawer && typeof window.elCartDrawer.bootstrapThemeCartDrawer === 'function') {
      window.elCartDrawer.bootstrapThemeCartDrawer();
    }
    document.dispatchEvent(new CustomEvent('cart:open'));
    var icon = document.querySelector('.js-drawer-open-cart');
    if (icon) icon.click();
  }

  async function handleAddToCheckout(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const variantId = getVariantId();
    if (!variantId) return;

    const selected = getSelectedVariant();
    const isSub = subscriptionCheckbox && subscriptionCheckbox.checked;
    const sellingPlanId = isSub
      ? ((selected && selected.dataset.sellingPlanId) || (subscriptionCheckbox && subscriptionCheckbox.dataset.sellingPlanId) || '')
      : '';

    buyNowBtn.classList.add('el-loading');
    buyNowBtn.setAttribute('disabled', 'disabled');

    try {
      const payload = {
        id: Number(variantId),
        quantity: 1
      };

      if (isSub && sellingPlanId) {
        payload.selling_plan = Number(sellingPlanId);
      }

      const useDrawer = document.body.getAttribute('data-el-cart-drawer') === 'true';

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify(useDrawer ? { items: [payload] } : payload)
      });

      if (!addResponse.ok) {
        const error = await addResponse.json().catch(() => ({}));
        throw new Error(error.description || error.message || `Unable to add the item (${addResponse.status})`);
      }

      if (useDrawer) {
        openThemeCartDrawer();
        buyNowBtn.classList.remove('el-loading');
        buyNowBtn.removeAttribute('disabled');
      } else {
        window.location.href = '/checkout';
      }
    } catch (err) {
      console.error(err);
      buyNowBtn.classList.remove('el-loading');
      buyNowBtn.removeAttribute('disabled');
    }
  }

  buyNowBtn.addEventListener('click', handleAddToCheckout);
  form.addEventListener('submit', handleAddToCheckout);

  updatePrices();
});

document.addEventListener('DOMContentLoaded', function () {
  const sticky = document.querySelector('.product-offer__sticky');
  const wrapper = document.querySelector('.product-offer__container');
  const footer = document.querySelector('.el-site-footer');

  if (!sticky) return;

  let passedWrapper = false;

  if (wrapper) {
    const wrapperObserver = new IntersectionObserver(
      ([entry]) => {
        passedWrapper = !entry.isIntersecting;

        if (passedWrapper) {
          sticky.classList.add('fixed');
        } else {
          sticky.classList.remove('fixed');
        }
      },
      { threshold: 0 }
    );

    wrapperObserver.observe(wrapper);
  }

  if (footer) {
    const footerObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sticky.classList.remove('fixed');
        } else {
          if (passedWrapper) {
            sticky.classList.add('fixed');
          }
        }
      },
      { threshold: 0 }
    );

    footerObserver.observe(footer);
  }
});

window.addEventListener('pageshow', () => {
  const btn = document.getElementById('buy-now');
  if (!btn) return;

  btn.classList.remove('el-loading');
  btn.disabled = false;
});

document.addEventListener('DOMContentLoaded', function() {
  function closeAccordionItem(item) {
    const content = item.querySelector('.product-offer__acc-item-description');
    if (!content) return;
    item.classList.remove('is-open');
    content.style.height = '0px';
    content.style.paddingBottom = '0px';
  }

  function openAccordionItem(item) {
    const content = item.querySelector('.product-offer__acc-item-description');
    if (!content) return;
    item.classList.add('is-open');
    content.style.height = 'auto';
    const fullHeight = content.scrollHeight + 'px';
    content.style.height = '0px';

    requestAnimationFrame(() => {
      content.style.height = fullHeight;
      content.style.paddingBottom = '20px';
    });
  }

  document.querySelectorAll('.product-offer__accordion-container').forEach(container => {
    const items = container.querySelectorAll('.product-offer__acc-item');
    let defaultOpened = false;

    items.forEach(item => {
      const trigger = item.querySelector('.product-offer__acc-item-title');
      const content = item.querySelector('.product-offer__acc-item-description');
      if (!trigger || !content) return;

      content.style.overflow = 'hidden';

      if (item.dataset.openByDefault === 'true' && !defaultOpened) {
        openAccordionItem(item);
        defaultOpened = true;
      } else {
        closeAccordionItem(item);
      }

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        items.forEach(otherItem => {
          if (otherItem !== item) {
            closeAccordionItem(otherItem);
          }
        });

        if (isOpen) {
          closeAccordionItem(item);
        } else {
          openAccordionItem(item);
        }
      });
    });
  });
});